import ForceScanId from './ForceScanId.jsx';

export default ForceScanId;